import React from "react";

const Java_Native = () => {
  return (
    <div>
      <h1>Java Native</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Native in Java.</p>
    </div>
  );
};

export default Java_Native;
